/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { Animated, StyleProp, ViewStyle, TextStyle } from "react-native";
import SVG_Svg, { G as SVG_G, Path as SVG_Path, GProps, PathProps } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <desc id="IMP.BLUE"></desc>
 * <g id="BackIcon">
 * <path id="Icon / Back" d="M0.233848 8.57101L7.42897 15.7637C7.74469 16.0787 8.2562 16.0787 8.57272 15.7637C8.88844 15.4488 8.88844 14.9373 8.57272 14.6224L1.9483 8.00036L8.57192 1.37834C8.88764 1.06342 8.88764 0.551907 8.57192 0.23619C8.2562 -0.07873 7.74389 -0.07873 7.42818 0.23619L0.233051 7.42886C-0.0778164 7.74052 -0.0778163 8.26007 0.233848 8.57101Z" fill="black"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {}
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  colorFill?: string;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const BackIcon = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  colorFill?: string;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const { colorFill = "#000000", svgRef } = props;
  /** End Custom React-Hooks */

  /** Component Render (Javascript-React Markup) */

  return (
    <Svg viewBox="0 0 9 16" fill="none" id="svg_root" ref={svgRef} >
      <G id="BackIcon">
        <Path
          id="Icon_20_20Back"
          d="M0.233848 8.57101L7.42897 15.7637C7.74469 16.0787 8.2562 16.0787 8.57272 15.7637C8.88844 15.4488 8.88844 14.9373 8.57272 14.6224L1.9483 8.00036L8.57192 1.37834C8.88764 1.06342 8.88764 0.551907 8.57192 0.23619C8.2562 -0.07873 7.74389 -0.07873 7.42818 0.23619L0.233051 7.42886C-0.0778164 7.74052 -0.0778163 8.26007 0.233848 8.57101Z"
          fill={colorFill}
          strokeWidth="30"
          vectorEffect="non-scaling-stroke"
        />
      </G>
    </Svg>
  );
};
/***/

export default React.memo(BackIcon);
